import { Mutations } from '@/util/settings/enums';
const mutations = {
    [Mutations.SET_USER_FIRST_NAME_VALUE](state, value) {
        state.firstName = value;
    },
    [Mutations.SET_USER_FAMILY_NAME_VALUE](state, value) {
        state.familyName = value;
    },
    [Mutations.SET_USER_OTHER_NAMES_VALUE](state, value) {
        state.otherNames = value;
    },
    [Mutations.SET_USER_TITLE_VALUE](state, value) {
        state.title = value;
    },
    [Mutations.SET_USER_MOBILE_NUMBER_VALUE](state, value) {
        state.mobileNumber = value;
    },
    [Mutations.SET_USER_ALTERNATIVE_NUMBER_VALUE](state, value) {
        state.alternativeContactNumber = value;
    },
    [Mutations.SET_FORM_DATA](state, value) {
        /* eslint-disable no-param-reassign */
        state = value;
    }
};
export default mutations;
